export const contentTableConfig = {
  title: '访问记录',
  propList: [
    {
      prop: 'deptName',
      label: '部门名称',
      minWidth: '80',
      slotName: 'dept'
    },
    {
      prop: 'channelName',
      label: '渠道',
      minWidth: '80',
      slotName: 'channel'
    },
    {
      prop: 'count',
      label: '新客户数量',
      minWidth: '80'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
